import { LifeBuoy } from "lucide-react";
import { SidebarMenuButton, SidebarMenuItem } from "../ui/sidebar";

export type SupportConfiguration = {
  email: string;
  responseWindow: string;
};

type SupportEnvironment = {
  VITE_SUPPORT_EMAIL?: string;
  VITE_SUPPORT_RESPONSE_WINDOW?: string;
};

const EMAIL_PATTERN = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

export function supportConfigurationFromEnvironment(
  environment: SupportEnvironment
): SupportConfiguration | null {
  const email = environment.VITE_SUPPORT_EMAIL?.trim();
  const responseWindow = environment.VITE_SUPPORT_RESPONSE_WINDOW?.trim();

  if (!email || !responseWindow || !EMAIL_PATTERN.test(email)) {
    return null;
  }

  return { email, responseWindow };
}

type SupportMenuItemProps = {
  configuration: SupportConfiguration | null;
};

export function SupportMenuItem({ configuration }: SupportMenuItemProps) {
  if (!configuration) {
    return null;
  }

  const subject = encodeURIComponent("IO Spoke support request");
  const accessibleLabel = `Contact IO Spoke support by email. Response window: ${configuration.responseWindow}.`;

  return (
    <SidebarMenuItem>
      <SidebarMenuButton
        asChild
        size="lg"
        tooltip="Contact support"
      >
        <a
          href={`mailto:${configuration.email}?subject=${subject}`}
          aria-label={accessibleLabel}
        >
          <LifeBuoy aria-hidden="true" />
          <span className="flex min-w-0 flex-col leading-tight group-data-[collapsible=icon]:hidden">
            <span>Contact support</span>
            <span className="text-xs text-sidebar-foreground/70">
              {configuration.responseWindow}
            </span>
          </span>
        </a>
      </SidebarMenuButton>
    </SidebarMenuItem>
  );
}
